<template>
  <div v-if="showModal" class="modal fade" id="AddNewBookModal" tabindex="-1" aria-labelledby="AddNewBookModalLabel"
    aria-hidden="true">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="modal-dialog">
      <div class="modal-content AddNewBookModal_content">
        <div class="modal-header AddNewBookModal_header">
          <h5 class="modal-title" id="AddNewBookModalLabel">
            <img src="../../../assets/images/left.svg" class="me-2" width="20" height="20" />
            Add Upcoming Book
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="processForm">
          <!-- error messages for form validation -->
          <div v-if="errors.length" style="color:white;">
            <b>Please correct the following error(s):</b>
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row align-items-center mb-3">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Audio Book's Name</label>
                </div>
                <div class="col-12 col-md-8">
                  <input type="text" class="form-control bg-input border-0" v-model="name" required />
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Audio Book's EnName</label>
                </div>
                <div class="col-12 col-md-8">
                  <input type="text" class="form-control bg-input border-0" v-model="en_name" required />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Contribute</label>
                </div>
                <div class="col-12 col-md-8">
                  <Select2
                      class="text-black"
                    v-model="contributingArtists"
                    :options="cast"
                    :settings="{
                      width: '100%',
                      placeholder: 'Select Contribute',
                      multiple: true,
                    }"
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="typo__label">Category</label>
                </div>
                <div class="col-12 col-md-8">
                  <multiselect v-model="categoryValue" tag-placeholder="Add this as new tag"
                    placeholder="Select category" :options="categories" label="name" track-by="id" required
                    :multiple="true"></multiselect>
                  <!-- <pre
                      class="language-json"
                    ><code>{{ categoryValue  }}</code></pre> -->
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Author Name</label>
                </div>
                <div class="col-12 col-md-8">
                  <Select2
                      class="text-black"
                    v-model="author"
                    :options="authorList"
                    :settings="{
                      width: '100%',
                      placeholder: 'Select Contribute',
                      multiple: true,
                    }"
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Description</label>
                </div>
                <div class="col-12 col-md-8">
                  <textarea type="text" class="form-control bg-input border-0" rows="2" v-model="description"
                    required></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label class="form-label star_after">Price</label>
                </div>
                <div class="col-12 col-md-8">
                  <input type="number" class="form-control bg-input border-0" required v-model="price"
                    :disabled="isFree" />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label for="c_image" class="form-label">Audiobook Image</label>
                </div>
                <div class="col-12 col-md-8">
                  <input class="form-control bg-input border-0" type="file" name="c_image" id="c_image"
                    aria-describedby="imageHelp" accept="image/gif, image/jpeg, image/png, image/svg"
                    @change="onAudiobookImageChange" required />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label for="c_image" class="form-label">Banner Image</label>
                </div>
                <div class="col-12 col-md-8">
                  <input class="form-control bg-input border-0" type="file" name="c_image" id="c_image"
                    aria-describedby="imageHelp" accept="image/gif, image/jpeg, image/png, image/svg"
                    @change="onBannerImageChange" required />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-md-4">
                  <label for="audio" class="form-label">Audio File</label>
                </div>
                <div class="col-12 col-md-8">
                  <input class="form-control bg-input border-0" type="file" name="audio" id="audio"
                    accept="audio/mpeg, audio/wav, audio/ogg" @change="onAudiobookTrackChange" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">
              Close
            </button>
            <button type="submit" class="btn btn-primary btn-sm">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

export default {
  name: "AddAudioBookModal",
  components: {
    Loading
  },
  props: ["getUpcomingList"],
  data() {
    return {
      progressStatus: true,
      currentStep: null,
      errors: [],
      cast: [],
      authorList: [],
      categories: [],
      categoryValue: [],
      selectCategoryId: "",
      haveEpisode: 0,
      multiAudioFileCount: 0,
      isFree: false,
      hasPrice: "Yes",
      name: undefined,
      en_name: undefined,
      description: undefined,
      author: [],
      price: 0.0,
      contributingArtists: [],
      selectAudiobookImage: undefined,
      selectBannerImage: undefined,
      selectAudiobookTrack: undefined,
      selectAudiobookTracks: [],
      episodeNames: [],
      episodes: [],
      episodeList: [],
      audioList: [],
      audiobookImageUrl: "",
      bannerImageUrl: "",
      token: localStorage.getItem(this.$tokenKey),
      tmpChannel: localStorage.getItem("tempChannelId"),
      isLoading: false,
      fullPage: true,
      loader: "bars",
      showModal: true
    };
  },
  methods: {
    processForm() {
            this.createAudiobook();

    },
    checkForm() {
      if (
        this.name &&
        this.en_name &&
        this.description &&
        this.categoryValue &&
        this.author &&
        this.contributingArtists
      ) {

      }
      this.errors = [];
      if (!this.name) {
        this.errors.push("name required.");
        return false;
      }
      if (!this.en_name) {
        this.errors.push("EnName required.");
        return false;
      }
      if (!this.description) {
        this.errors.push("description required.");
        return false;
      }
      if (!this.author) {
        this.errors.push("author required.");
        return false;
      }
      if (!this.contributingArtists) {
        this.errors.push("contributingArtists required.");
        return false;
      }
      if (!this.categoryValue) {
        this.errors.push("category required");
      }
      return false;
    },

    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
        this.$baseUrl + this.$api + this.$version1 + "/categories",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status == 200) {
        this.categories = res.data.map((el) => {
          return { id: el.id, name: el.name };
        });
        this.isLoading = false;
      }
    },
    async getCast() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
        this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/getall",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        this.cast = res.data.data.map((el) => {
          return  el.name
        });
        this.isLoading = false;
      }
    },
    async getAuthorList() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
        this.$baseUrl + this.$api + this.$version1 + "/audiobooks/authors/getall",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        this.authorList = res.data.data.map((el) => {
          return  el.name
        });
        this.isLoading = false;
      }
    },
    onAudiobookImageChange(event) {
      this.selectAudiobookImage = event.target.files[0];
    },
    onBannerImageChange(event) {
      this.selectBannerImage = event.target.files[0];
    },
    onAudiobookTrackChange(event) {
      this.selectAudiobookTrack = event.target.files[0];
    },
    onAudiobookTrackChangeMulti(index) {
      this.audioList[index] = this.$refs.audios[index].files[0];
    },
    async createAudiobook() {
      this.isLoading = true;
      let stringifyCategory = JSON.stringify(this.categoryValue);
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("en_name", this.en_name);
      formData.append("description", this.description);
      formData.append("author", this.author.toString());
      formData.append(
        "contributingArtists",
        this.contributingArtists.toString()
      );
      formData.append("price", this.price);
      formData.append("categoryValue", stringifyCategory);
      formData.append("files", this.selectAudiobookImage);
      formData.append("files", this.selectAudiobookTrack);
      formData.append("files", this.selectBannerImage);
      const res = await axios.post(
        this.$baseUrl + this.$api + this.$version4 + "/upcoming",
        formData,
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      this.isLoading = false;
      if (res.status === 201 || res.status === 200) {
        this.showModal = false
        await this.getUpcomingList()
        this.$swal.fire({
          icon: "success",
          title: "Your work has been saved",
          showConfirmButton: true,
        })
      } else {
        this.$vToastify.error("Could not create audiobook");
      }
    },
  },
  mounted() {
    // use this for get
    this.getData();
    this.getCast();
    this.getAuthorList();
  },
};
</script>

<style scoped>
</style>
